module.exports = __webpack_public_path__ + "static/media/opened-eye.de1f4f69.svg";